import { createNextTableContext } from '@core/table';

export const PartnerDeclarationTableContext = createNextTableContext();
